<template>
    <!-- ベーシックモーダル START -->
    <BasicModal
        :width="'1240px'"
        :height="'580px'"
        :title="'求人ページ変更履歴'"
        :isShowModal="isShowModal"
        :canCancel="true"
        @cancel="cancel"
    >
        <p style="font-size: x-small;"> ※求人原稿の画像変更は履歴が残りませんのでご了承ください。</p>
        <!-- 変更履歴テーブル -->
        <div class="card-body" v-if="!isChangeHistoryLoading">
            <!-- 変更履歴が存在している場合 -->
            <table v-if="EmploymentChangeHistory" class="table-box disp-scroll">
                <tr>
                    <th style="width: 10%;" class="table-th">操作</th>
                    <th style="width: 16%;" class="table-th">項目</th>
                    <th style="width: 16%;" class="table-th">変更前</th>
                    <th style="width: 16%;" class="table-th">変更後</th>
                    <th style="width: 16%;" class="table-th">変更者</th>
                    <th style="width: 16%;" class="table-th">変更日時</th>
                </tr>
                <tr v-for="(history, idx) in EmploymentChangeHistory" :key="idx">
                    <td style="width: 10%; vertical-align: middle;">
                        <p class="history">{{history.operation}}</p>
                    </td>
                    <td style="width: 16%; vertical-align: middle;">
                        <p class="history">{{history.item_name}}</p>
                    </td>
                    <td style="width: 16%; vertical-align: middle;">
                        <p class="history">{{history.before_content}}</p>
                    </td>
                    <td style="width: 16%; vertical-align: middle;">
                        <p class="history">{{history.after_content}}</p>
                    </td>
                    <td style="width: 16%; vertical-align: middle;">
                        <p class="history">{{history.updater}}</p>
                    </td>
                    <td style="width: 16%; vertical-align: middle;">
                        <p class="history">{{getDate(history.created_at)}}</p>
                    </td>
                </tr>
            </table>
            <!-- 変更履歴が存在していない場合 -->
            <table v-else>
                変更履歴はありません
            </table>
        </div>
        <!-- 変更履歴取得中表示 -->
        <div class="card-body" v-else>
            <span class="mdi mdi-spin mdi-loading mdi-48px" style="position: absolute; top: 50%; left: 50%;"></span>
        </div>
        <!-- フッターアクション -->
        <div class="footer-box">
            <button class="button" @click="cancel">
                戻る
            </button>
        </div>
    </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
    components: {
        BasicModal,
    },
    props: {
        isShowModal: {
            type: Boolean,
            required: true,
        },
        contentId: {
            type: String,
            required: true,
        }
    },
    data () {
        return {
            EmploymentChangeHistory: null,
            isChangeHistoryLoading: false,
        }
    },
    mounted () {
        // ローディングON
        this.isChangeHistoryLoading = true
        // 変更履歴の取得
        this.$store.dispatch('employmentPage/getEmploymentChangeHistory', this.contentId)
        .then((history) => {
            if (history.length > 0) {
                // 取得したデータの格納
                this.EmploymentChangeHistory = history
            } else {
                // 何もデータがない場合はnullを格納する
                this.EmploymentChangeHistory = null
            }
            // ローディングOFF
            this.isChangeHistoryLoading = false
        })
    },
    methods: {
        // モーダル表示キャンセル処理
        cancel () {
            this.$emit('cancel', false)
        },
        // 変更履歴のcreated_at用の時間表示処理
        getDate (date) {
            var time = new Date(date)
            if (date == null) return null
            else return time.getFullYear() + '/' + (time.getMonth() + 1) + '/' + time.getDate() + ' ' + time.getHours() + ':' + ('00' + time.getMinutes()).slice(-2)
        },
    },
}
</script>

<style lang="scss" scoped>
.card-body {
  height: 60vh;
}
.table-box {
    display: block;
    height: 100%;
    width: 100%;
    tr {
        display: table;
        width: 100%;
        td {
            padding: 8px;
            height: auto;
            min-height: 36px;
        }
    }
}
.table-th {
    padding: 2px 8px;
    text-align: center;
    vertical-align: middle;
    border: solid thin #ccc;
    font-size: 14px;
}
.history {
    // 英文字が連続で入力されていると表示崩れしてしまうので、単語内でも折り返しできるようにする設定
    word-break: break-all;
}
.footer-box {
    width: 100%;
    height: 64px;
    border-top: solid thin #ccc;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    overflow: auto;
    button {
        width: 47%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/EmploymentPage/ModalEmploymentChangeHistory.vue